import { defineMessages } from "react-intl"

export const offerMessages = defineMessages({
	actionButton: {
		defaultMessage: "Actions",
		id: "offer.actions",
	},
	addConfigurationButtonLabel: {
		defaultMessage: "Add Configuration",
		id: "offer.addConfigurationButtonLabel",
	},
	addOfferPageTitle: {
		defaultMessage: "Save Offer",
		id: "offer.addOfferPageTitle",
	},
	addOfferPageTitle_offerAsConfiguration: {
		defaultMessage: "Save Configuration",
		id: "offer.addOfferPageTitleWithOfferAsConfiguration",
	},
	addOfferPageTitle_reportSale: {
		defaultMessage: "Report Sale",
		id: "offer.addOfferPageTitle.reportSale",
	},
	capUnavailableBannerDescription: {
		defaultMessage:
			"You can proceed without assigning a business partner and assign one once C@P is available again.",
		id: "offer.capUnavailableBannerDescription",
	},
	capUnavailableBannerHeading: {
		defaultMessage: "C@P temporarily unavailable",
		id: "offer.capUnavailableBannerHeading",
	},
	capWarningDescription: {
		defaultMessage: "You can enter the name of the customer manually and try again later.",
		id: "offer.capWarningDescription",
	},
	capWarningHeading: {
		defaultMessage: "The customer data could not be imported from the C@P.",
		id: "offer.capWarningHeading",
	},
	editListItems_addButton: {
		defaultMessage: "Add",
		id: "offer.editListItems.addButton",
	},
	editListItems_applyRow: {
		defaultMessage: "Apply",
		id: "offer.editListItems.applyRow",
	},
	editListItems_cancelEdit: {
		defaultMessage: "Cancel",
		id: "offer.editListItems.cancelEdit",
	},
	editListItems_deleteRow: {
		defaultMessage: "Delete",
		id: "offer.editListItems.deleteRow",
	},
	editListItems_editRow: {
		defaultMessage: "Edit",
		id: "offer.editListItems.editRow",
	},
	editListItems_incompleteEditBanner: {
		defaultMessage: "Complete or cancel the current edit before saving.",
		id: "offer.editListItems.incompleteEditBanner",
	},
	editOfferPageTitle_saveOffer: {
		defaultMessage: "Save Offer",
		id: "offer.editOfferPageTitle.saveOffer",
	},
	editOfferPageTitle_updateSale: {
		defaultMessage: "Update Sale",
		id: "offer.editOfferPageTitle.updateSale",
	},
	editOfferPageTitleWithOfferAsConfiguration: {
		defaultMessage: "Save Configuration",
		id: "offer.editOfferPageTitleWithOfferAsConfiguration",
	},

	customerAddFromCapLabel: {
		defaultMessage: "Add customer from C@P",
		id: "offer.customerAddFromCap",
	},
	customerBusinessPartnerIdLabel: {
		defaultMessage: "Business partner ID",
		id: "offer.customerBusinessPartnerIdLabel",
	},
	customerEditCapCustomer: {
		defaultMessage: "Edit Customer",
		id: "offer.customerEditCapCustomer",
	},
	customerNameFieldLabel: {
		defaultMessage: "Customer Name",
		id: "offer.customerNameFieldLabel",
	},
	customerNameHint: {
		defaultMessage: "Enter the Name manually or select a customer from C@P.",
		id: "offer.customerNameHint",
	},
	customerStageTitle: {
		defaultMessage: "Customer",
		id: "offer.customerStageTitle",
	},
	deleteConfigurationMenuLabel: {
		defaultMessage: "Delete Configuration",
		id: "offer.deleteConfigurationMenuLabel",
	},
	displayOwnOffersOnlyCheckboxLabel: {
		defaultMessage: "Created by me",
		id: "offer.displayOwnOffersOnlyCheckboxLabel",
	},
	failedToLoadOffer: {
		defaultMessage: "Failed to load offer",
		id: "offer.failedToLoadOffer",
	},
	invalidConfigurationBannerActionLabel: {
		defaultMessage: "Open in Configurator",
		id: "offer.invalidConfigurationBannerActionLabel",
	},
	invalidConfigurationBannerDescription: {
		defaultMessage:
			"Some options might have changed or are no longer available. Please open the configuration in the configurator to review and update it.",
		id: "offer.invalidConfigurationBannerDescription",
	},
	invalidConfigurationBannerHeading: {
		defaultMessage: "Your configuration is not up to date.",
		id: "offer.invalidConfigurationBannerHeading",
	},
	nameEmptyView: {
		defaultMessage: "This offer doesn't have a title yet.",
		id: "offer.nameEmptyView",
	},
	nameEmptyViewWithOfferAsConfiguration: {
		defaultMessage: "This configuration doesn't have a name yet.",
		id: "offer.nameEmptyViewWithOfferAsConfiguration",
	},
	nameFieldLabel: {
		defaultMessage: "Offer Title",
		id: "offer.nameFieldLabel",
	},
	nameFieldLabelWithOfferAsConfiguration: {
		defaultMessage: "Configuration Name",
		id: "offer.nameFieldLabelWithOfferAsConfiguration",
	},
	nameStageTitle: {
		defaultMessage: "Offer",
		id: "offer.nameStageTitle",
	},
	nameStageTitleWithOfferAsConfiguration: {
		defaultMessage: "Configuration",
		id: "offer.nameStageTitleWithOfferAsConfiguration",
	},
	noPorscheCodeError: {
		defaultMessage: "No Porsche code provided",
		id: "offer.noPorscheCodeError",
	},
	noVehicleIdentifierError: {
		defaultMessage: "No vehicleId or Porsche code provided",
		id: "offer.noVehicleIdentifierError",
	},
	offerDetailsPageTitle: {
		defaultMessage: "Offer Details",
		id: "offer.offerDetailsPageTitle",
	},
	offerDetailsPageTitleWithOfferAsConfiguration: {
		defaultMessage: "Configuration Details",
		id: "offer.offerDetailsPageTitleWithOfferAsConfiguration",
	},
	offerOverviewTitle_savedOffers: {
		defaultMessage: "Saved Offers",
		id: "offer.offerOverviewTitle.savedOffers",
	},
	offerOverviewTitleWithOfferAsConfiguration: {
		defaultMessage: "Saved Configurations",
		id: "offer.offerOverviewTitleWithOfferAsConfiguration",
	},
	overviewSearchPlaceholder_offerTitle: {
		defaultMessage: "Offer Title, Customer, or Sales Person",
		id: "offer.overviewSearchPlaceholder.offerTitle",
	},
	overviewSearchPlaceholderWithOfferAsConfiguration: {
		defaultMessage: "Configuration Name, Customer, or Sales Person",
		id: "offer.overviewSearchPlaceholderWithOfferAsConfiguration",
	},
	overviewTableCreationDateColumnTitle: {
		defaultMessage: "Creation Date",
		id: "offer.overviewTableCreationDateColumnTitle",
	},
	overviewTableCustomerColumnTitle: {
		defaultMessage: "Customer Name",
		id: "offer.overviewTableCustomerColumnTitle",
	},
	overviewTableNameColumnTitle_offerTitle: {
		defaultMessage: "Offer Title",
		id: "offer.overviewTableNameColumnTitle.offerTitle",
	},
	overviewTableNameColumnTitleWithOfferAsConfiguration: {
		defaultMessage: "Configuration Name",
		id: "offer.overviewTableNameColumnTitleWithOfferAsConfiguration",
	},
	overviewTableNoEntries_savedOffers: {
		defaultMessage: "No saved offers found.",
		id: "offer.overviewTableNoEntries.savedOffers",
	},
	overviewTableNoEntriesWithOfferAsConfiguration: {
		defaultMessage: "No saved configurations found.",
		id: "offer.overviewTableNoEntriesWithOfferAsConfiguration",
	},
	overviewTableOrderTypeNameColumnTitle: {
		defaultMessage: "Model",
		id: "offer.overviewTableOrderTypeNameColumnTitle",
	},
	overviewTableSalespersonColumnTitle: {
		defaultMessage: "Sales Person",
		id: "offer.overviewTableSalespersonColumnTitle",
	},
	overviewTableStatusColumnTitle: {
		defaultMessage: "Status",
		id: "offer.overviewTableStatusColumnTitle",
	},
	overviewTableTitle: {
		defaultMessage: "{total, plural, one {# offer} other {# offers}}",
		id: "offer.overviewTableTitle",
	},
	overviewTableTitleWithOfferAsConfiguration: {
		defaultMessage: "{total, plural, one {# configuration} other {# configurations}}",
		id: "offer.overviewTableTitleWithOfferAsConfiguration",
	},
	overviewTableVehicleTypeColumnTitle: {
		defaultMessage: "Vehicle Type",
		id: "offer.overviewTableVehicleTypeColumnTitle",
	},
	porscheCodeTooltip: {
		defaultMessage: "Porsche Code",
		id: "offer.porscheCodeTooltip",
	},
	priceChangeBannerChangedItem: {
		defaultMessage: "{code} | {name}: New price: {current} (previously {previous})",
		id: "offer.priceChangeBannerChangedItem",
	},
	priceChangeBannerHeading: {
		defaultMessage: "Price update",
		id: "offer.priceChangeBannerHeading",
	},
	priceChangeBannerSummary: {
		defaultMessage:
			"The price for this vehicle configuration has changed from {previous} to {current}. The affected configuration elements are listed below.",
		id: "offer.priceChangeBannerSummary",
	},
	salespersonTooltip: {
		defaultMessage: "Sales Person",
		id: "offer.salespersonTooltip",
	},
	save_andOpenInConfigurator: {
		defaultMessage: "Save and open in configurator",
		id: "offer.saveAndOpenInConfigurator",
	},
	save_configuration: {
		defaultMessage: "Save configuration",
		id: "offer.saveConfiguration",
	},
	save_offer: {
		defaultMessage: "Save offer",
		id: "offer.saveOffer",
	},
	save_reportSaleDisabledMissingCap: {
		defaultMessage: "Sale can only be reported if the customer is selected from C@P",
		id: "offer.save.reportSaleDisabledMissingCap",
	},
	save_reportSaleNext: {
		defaultMessage: "Next",
		id: "offer.save.reportSaleNext",
	},
	saveAsNew_andOpenInConfigurator: {
		defaultMessage: "Save as new configuration and open in configurator",
		id: "offer.saveAsNewConfigurationAndOpenInConfigurator",
	},
	saveAsNew_configuration: {
		defaultMessage: "Save as new configuration",
		id: "offer.saveAsNewConfiguration",
	},
	saveAsNew_offer: {
		defaultMessage: "Save as new offer",
		id: "offer.saveAsNewOffer",
	},
	saveAsNew_updateSaleNext: {
		defaultMessage: "Next",
		id: "offer.saveAsNew_updateSaleNext",
	},
	vehicleDataLoadError: {
		defaultMessage: "Failed to load vehicle data.",
		id: "offer.vehicleDataLoadError",
	},

	deleteModalCancelDeleteButton: {
		defaultMessage: "Cancel",
		id: "offer.deleteModalCancelDeleteButton",
	},
	deleteModalConfirmDeleteButton: {
		defaultMessage: "Delete",
		id: "offer.deleteModalConfirmDeleteButton",
	},
	deleteModalMessage: {
		defaultMessage: "Please confirm that you want to proceed with the deletion.",
		id: "offer.deleteModalMessage",
	},
	deleteModalSuccessToast: {
		defaultMessage: "Offer deleted.",
		id: "offer.deleteModalSuccessToast",
	},
	deleteModalSuccessToastWithOfferAsConfiguration: {
		defaultMessage: "Configuration deleted.",
		id: "offer.deleteModalSuccessToastWithOfferAsConfiguration",
	},
	deleteModalTitle: {
		defaultMessage: "Are you sure you want to delete this offer?",
		id: "offer.deleteModalTitle",
	},
	deleteModalTitleWithOfferAsConfiguration: {
		defaultMessage: "Are you sure you want to delete this configuration?",
		id: "offer.deleteModalTitleWithOfferAsConfiguration",
	},
	offerSavedSuccessToast: {
		defaultMessage: "Offer saved.",
		id: "offer.offerSavedSuccessToast",
	},
	offerSavedSuccessToastWithOfferAsConfiguration: {
		defaultMessage: "Configuration saved.",
		id: "offer.offerSavedSuccessToastWithOfferAsConfiguration",
	},

	transferOfferErrorToast: {
		defaultMessage: "Data transfer failed.",
		id: "offer.transferOfferErrorToast",
	},
	transferOfferSuccessToast: {
		defaultMessage: "Data transferred successfully.",
		id: "offer.transferOfferSuccessToast",
	},
	transferVehicleCancelButton: {
		defaultMessage: "Cancel",
		id: "offer.transferVehicleCancelButton",
	},
	transferVehicleConfirmButton: {
		defaultMessage: "Transfer Data",
		id: "offer.transferVehicleConfirmButton",
	},
	transferVehicleModalDescription: {
		defaultMessage: "Please select a customer from C@P to transfer the associated vehicle data.",
		id: "offer.transferVehicleModalDescription",
	},
	transferVehicleModalTitle: {
		defaultMessage: "Select customer to transfer data",
		id: "offer.transferVehicleModalTitle",
	},
	transferVehicleSelectCustomerButton: {
		defaultMessage: "Select customer from C@P",
		id: "offer.transferVehicleSelectCustomerButton",
	},
	transferVehicleSuccessToast: {
		defaultMessage: "Data transferred successfully.",
		id: "offer.transferVehicleSuccessToast",
	},
	vehicleTypeCsv: {
		defaultMessage: "Configuration",
		id: "offer.vehicleType.csv",
	},
	vehicleTypeStockCar: {
		defaultMessage: "Stock",
		id: "offer.vehicleType.stockCar",
	},
})
